/**
 * SERB Contract Snapshot Data
 * Generated from serb-monitor comparison reports (2026-08-28).
 *
 * serbIrns: Districts with contracts on SERB that may need loading.
 * notLoadedDistricts: All districts without 2026 data at snapshot time.
 *
 * The frontend compares these lists against the live API to compute:
 *   - In InsightBoard (live from DB)
 *   - In SERB, not loaded (serbIrns minus loaded)
 *   - Waiting for SERB (notLoadedDistricts minus serbIrns minus loaded)
 */

// Districts with 2026 contracts on SERB (from not_in_serb_matches_2026-08-28.csv)
// 2026-10-16 (#642): East Cleveland, Edison, Mansfield and Urbana removed — their latest SERB
// filings cover 2025 at most, so they count as Waiting for SERB (still in notLoadedDistricts).
export const serbIrns = {
  "043513": { name: "Ashtabula Area City", county: "ASHT" },
  "049171": { name: "Aurora City", county: "PORT" },
  "046300": { name: "Batavia Local", county: "CLER" },
  "043547": { name: "Bay Village City", county: "CUYA" },
  "043554": { name: "Beachwood City", county: "CUYA" },
  "046425": { name: "Beaver Local", county: "COLU" },
  "043588": { name: "Bellefontaine City", county: "LOGA" },
  "043612": { name: "Berea City", county: "CUYA" },
  "050096": { name: "Bloomfield-Mespo Local", county: "TRUM" },
  "043695": { name: "Cambridge City", county: "GUER" },
  "048314": { name: "Canfield Local", county: "MAHO" },
  "048793": { name: "Cardington-Lincoln Local", county: "MORR" },
  "045294": { name: "Chesapeake Union Exempted Village", county: "LAWR" },
  "049411": { name: "Clear Fork Valley Local", county: "RICH" },
  "046326": { name: "Clermont Northeastern Local", county: "CLER" },
  "043794": { name: "Cleveland Heights-University Heights City", county: "CUYA" },
  "049429": { name: "Crestview Local", county: "RICH" },
  "043935": { name: "Eaton Community City", county: "PREB" },
  "046102": { name: "Fairfield City", county: "BUTL" },
  "049775": { name: "Fairlawn Local", county: "SHEL" },
  "043984": { name: "Findlay City", county: "HANC" },
  "047332": { name: "Finneytown Local", county: "HAMI" },
  "047852": { name: "Fredericktown Local", county: "KNOX" },
  "050492": { name: "Frontier Local", county: "WASH" },
  "065680": { name: "Gallia County Local", county: "GALL" },
  "048942": { name: "Genoa Area Local", county: "OTTA" },
  "045377": { name: "Georgetown Exempted Village", county: "BROW" },
  "046342": { name: "Goshen Local", county: "CLER" },
  "046193": { name: "Graham Local", county: "CHAM" },
  "050013": { name: "Green Local", county: "SUMM" },
  "048801": { name: "Highland Local", county: "MORR" },
  "050161": { name: "Howland Local", county: "TRUM" },
  "045427": { name: "Hubbard Exempted Village", county: "TRUM" },
  "048751": { name: "Huber Heights City", county: "MONT" },
  "050021": { name: "Hudson City", county: "SUMM" },
  "049502": { name: "Huntington Local", county: "ROSS" },
  "044149": { name: "Ironton City School District", county: "LAWR" },
  "048322": { name: "Jackson-Milton Local", county: "MAHO" },
  "050179": { name: "Joseph Badger Local", county: "TRUM" },
  "048165": { name: "Keystone Local", county: "LORA" },
  "044206": { name: "Lancaster City", county: "FAIR" },
  "048009": { name: "Licking Heights Local", county: "LICK" },
  "050443": { name: "Little Miami Local", county: "WARR" },
  "049874": { name: "Louisville City", county: "STAR" },
  "046128": { name: "Madison Local", county: "BUTL" },
  "044339": { name: "Marion City", county: "MARI" },
  "044347": { name: "Martins Ferry City", county: "BELM" },
  "045476": { name: "Marysville Exempted Village", county: "UNIO" },
  "050153": { name: "Mathews Local", county: "TRUM" },
  "044388": { name: "Medina City SD", county: "MEDI" },
  "046920": { name: "Miami Trace Local", county: "FAYE" },
  "045518": { name: "Milton-Union Exempted Village", county: "MIAM" },
  "050039": { name: "Mogadore Local", county: "SUMM" },
  "044420": { name: "Mount Vernon City", county: "KNOX" },
  "044412": { name: "Mt Healthy City", county: "HAMI" },
  "049270": { name: "National Trail Local", county: "PREB" },
  "045542": { name: "Newcomerstown Exempted Village", county: "TUSC" },
  "045567": { name: "Newton Falls Exempted Village", county: "TRUM" },
  "044511": { name: "North College Hill City", county: "HAMI" },
  "044545": { name: "North Royalton City", county: "CUYA" },
  "048033": { name: "Northridge Local", county: "LICK" },
  "046268": { name: "Northwestern Local", county: "CLAR" },
  "044560": { name: "Norwalk City", county: "HURO" },
  "044578": { name: "Norwood City", county: "HAMI" },
  "049510": { name: "Paint Valley Local", county: "ROSS" },
  "048348": { name: "Poland Local", county: "MAHO" },
  "044669": { name: "Portsmouth City", county: "SCIO" },
  "049288": { name: "Preble Shawnee Local", county: "PREB" },
  "045880": { name: "Pymatuning Valley Local", county: "ASHT" },
  "044685": { name: "Ravenna City", county: "PORT" },
  "046474": { name: "Ridgewood Local", county: "COSH" },
  "046144": { name: "Ross Local", county: "BUTL" },
  "045609": { name: "Rossford Exempted Village", county: "WOOD" },
  "049684": { name: "Seneca East Local", county: "SENE" },
  "045799": { name: "Shawnee Local", county: "ALLE" },
  "046607": { name: "Solon City", county: "CUYA" },
  "048363": { name: "South Range Local", county: "MAHO" },
  "049528": { name: "Southeastern Local", county: "ROSS" },
  "048538": { name: "Southern Local", county: "MEIG" },
  "048371": { name: "Springfield Local", county: "MAHO" },
  "050062": { name: "Springfield Local", county: "SUMM" },
  "044719": { name: "St Bernard-Elmwood Place City", county: "HAMI" },
  "048587": { name: "St Henry Consolidated Local", county: "MERC" },
  "044834": { name: "Stow-Munroe Falls City School District", county: "SUMM" },
  "050294": { name: "Strasburg-Franklin Local", county: "TUSC" },
  "044883": { name: "Tallmadge City", county: "SUMM" },
  "049098": { name: "Teays Valley Local", county: "PICK" },
  "044891": { name: "Tiffin City Schools", county: "SENE" },
  "046011": { name: "Union Local", county: "BELM" },
  "046904": { name: "Walnut Township Local", county: "FAIR" },
  "050500": { name: "Warren Local", county: "WASH" },
  "049148": { name: "Waverly City", county: "PIKE" },
  "050252": { name: "Weathersfield Local", county: "TRUM" },
  "047696": { name: "West Holmes Local", county: "HOLM" },
  "049155": { name: "Western Local", county: "PIKE" },
  "047746": { name: "Western Reserve Local", county: "HURO" },
  "049106": { name: "Westfall Local", county: "PICK" },
  "050518": { name: "Wolf Creek Local", county: "WASH" },
  "049973": { name: "Woodridge Local", county: "SUMM" },
  "045120": { name: "Wooster City", county: "WAYN" },
};

// All districts without 2026 data at snapshot time (from not_in_serb_districts_2026-08-28.csv)
// Includes SERB-matched and non-matched districts.
export const notLoadedDistricts = {
  "061903": { name: "Adams County Ohio Valley Local", county: "ADAM" },
  "043513": { name: "Ashtabula Area City", county: "ASHT" },
  "049171": { name: "Aurora City", county: "PORT" },
  "046300": { name: "Batavia Local", county: "CLER" },
  "043547": { name: "Bay Village City", county: "CUYA" },
  "043554": { name: "Beachwood City", county: "CUYA" },
  "046425": { name: "Beaver Local", county: "COLU" },
  "043562": { name: "Bedford City", county: "CUYA" },
  "043588": { name: "Bellefontaine City", county: "LOGA" },
  "043612": { name: "Berea City", county: "CUYA" },
  "050096": { name: "Bloomfield-Mespo Local", county: "TRUM" },
  "043695": { name: "Cambridge City", county: "GUER" },
  "048314": { name: "Canfield Local", county: "MAHO" },
  "048793": { name: "Cardington-Lincoln Local", county: "MORR" },
  "045294": { name: "Chesapeake Union Exempted Village", county: "LAWR" },
  "043752": { name: "Cincinnati Public Schools", county: "HAMI" },
  "049411": { name: "Clear Fork Valley Local", county: "RICH" },
  "046326": { name: "Clermont Northeastern Local", county: "CLER" },
  "043794": { name: "Cleveland Heights-University Heights City", county: "CUYA" },
  "049429": { name: "Crestview Local", county: "RICH" },
  "043844": { name: "Dayton City", county: "MONT" },
  "043901": { name: "East Cleveland City School District", county: "CUYA" },
  "043935": { name: "Eaton Community City", county: "PREB" },
  "047795": { name: "Edison Local", county: "JEFF" },
  "046102": { name: "Fairfield City", county: "BUTL" },
  "049775": { name: "Fairlawn Local", county: "SHEL" },
  "045914": { name: "Federal Hocking Local", county: "ATHE" },
  "043984": { name: "Findlay City", county: "HANC" },
  "047332": { name: "Finneytown Local", county: "HAMI" },
  "047852": { name: "Fredericktown Local", county: "KNOX" },
  "050492": { name: "Frontier Local", county: "WASH" },
  "065680": { name: "Gallia County Local", county: "GALL" },
  "044040": { name: "Garfield Heights City Schools", county: "CUYA" },
  "048942": { name: "Genoa Area Local", county: "OTTA" },
  "045377": { name: "Georgetown Exempted Village", county: "BROW" },
  "046342": { name: "Goshen Local", county: "CLER" },
  "046193": { name: "Graham Local", county: "CHAM" },
  "050013": { name: "Green Local", county: "SUMM" },
  "048801": { name: "Highland Local", county: "MORR" },
  "050161": { name: "Howland Local", county: "TRUM" },
  "045427": { name: "Hubbard Exempted Village", county: "TRUM" },
  "048751": { name: "Huber Heights City", county: "MONT" },
  "050021": { name: "Hudson City", county: "SUMM" },
  "049502": { name: "Huntington Local", county: "ROSS" },
  "044149": { name: "Ironton City School District", county: "LAWR" },
  "048322": { name: "Jackson-Milton Local", county: "MAHO" },
  "050179": { name: "Joseph Badger Local", county: "TRUM" },
  "048165": { name: "Keystone Local", county: "LORA" },
  "044206": { name: "Lancaster City", county: "FAIR" },
  "048009": { name: "Licking Heights Local", county: "LICK" },
  "050443": { name: "Little Miami Local", county: "WARR" },
  "049874": { name: "Louisville City", county: "STAR" },
  "046128": { name: "Madison Local", county: "BUTL" },
  "044297": { name: "Mansfield City", county: "RICH" },
  "044339": { name: "Marion City", county: "MARI" },
  "044347": { name: "Martins Ferry City", county: "BELM" },
  "045476": { name: "Marysville Exempted Village", county: "UNIO" },
  "050153": { name: "Mathews Local", county: "TRUM" },
  "044388": { name: "Medina City SD", county: "MEDI" },
  "046920": { name: "Miami Trace Local", county: "FAYE" },
  "045518": { name: "Milton-Union Exempted Village", county: "MIAM" },
  "050039": { name: "Mogadore Local", county: "SUMM" },
  "139303": { name: "Monroe Local", county: "BUTL" },
  "044420": { name: "Mount Vernon City", county: "KNOX" },
  "044412": { name: "Mt Healthy City", county: "HAMI" },
  "049270": { name: "National Trail Local", county: "PREB" },
  "045542": { name: "Newcomerstown Exempted Village", county: "TUSC" },
  "045567": { name: "Newton Falls Exempted Village", county: "TRUM" },
  "044511": { name: "North College Hill City", county: "HAMI" },
  "044545": { name: "North Royalton City", county: "CUYA" },
  "048033": { name: "Northridge Local", county: "LICK" },
  "049635": { name: "Northwest Local", county: "SCIO" },
  "046268": { name: "Northwestern Local", county: "CLAR" },
  "044560": { name: "Norwalk City", county: "HURO" },
  "044578": { name: "Norwood City", county: "HAMI" },
  "049510": { name: "Paint Valley Local", county: "ROSS" },
  "044636": { name: "Parma City", county: "CUYA" },
  "048348": { name: "Poland Local", county: "MAHO" },
  "044669": { name: "Portsmouth City", county: "SCIO" },
  "049288": { name: "Preble Shawnee Local", county: "PREB" },
  "045880": { name: "Pymatuning Valley Local", county: "ASHT" },
  "044685": { name: "Ravenna City", county: "PORT" },
  "050054": { name: "Revere Local", county: "SUMM" },
  "046599": { name: "Richmond Heights Local", county: "CUYA" },
  "046474": { name: "Ridgewood Local", county: "COSH" },
  "047944": { name: "Rock Hill Local", county: "LAWR" },
  "046144": { name: "Ross Local", county: "BUTL" },
  "045609": { name: "Rossford Exempted Village", county: "WOOD" },
  "049684": { name: "Seneca East Local", county: "SENE" },
  "045799": { name: "Shawnee Local", county: "ALLE" },
  "046607": { name: "Solon City", county: "CUYA" },
  "048363": { name: "South Range Local", county: "MAHO" },
  "049528": { name: "Southeastern Local", county: "ROSS" },
  "048538": { name: "Southern Local", county: "MEIG" },
  "048371": { name: "Springfield Local", county: "MAHO" },
  "050062": { name: "Springfield Local", county: "SUMM" },
  "044719": { name: "St Bernard-Elmwood Place City", county: "HAMI" },
  "048587": { name: "St Henry Consolidated Local", county: "MERC" },
  "044834": { name: "Stow-Munroe Falls City School District", county: "SUMM" },
  "050294": { name: "Strasburg-Franklin Local", county: "TUSC" },
  "044883": { name: "Tallmadge City", county: "SUMM" },
  "049098": { name: "Teays Valley Local", county: "PICK" },
  "044891": { name: "Tiffin City Schools", county: "SENE" },
  "045922": { name: "Trimble Local", county: "ATHE" },
  "050591": { name: "Triway Local", county: "WAYN" },
  "048694": { name: "Trotwood-Madison City", county: "MONT" },
  "046011": { name: "Union Local", county: "BELM" },
  "044941": { name: "Urbana City", county: "CHAM" },
  "046904": { name: "Walnut Township Local", county: "FAIR" },
  "050500": { name: "Warren Local", county: "WASH" },
  "049148": { name: "Waverly City", county: "PIKE" },
  "050252": { name: "Weathersfield Local", county: "TRUM" },
  "047696": { name: "West Holmes Local", county: "HOLM" },
  "049155": { name: "Western Local", county: "PIKE" },
  "047746": { name: "Western Reserve Local", county: "HURO" },
  "049106": { name: "Westfall Local", county: "PICK" },
  "045062": { name: "Westlake City", county: "CUYA" },
  "045088": { name: "Wickliffe City", county: "LAKE" },
  "046367": { name: "Williamsburg Local", county: "CLER" },
  "050518": { name: "Wolf Creek Local", county: "WASH" },
  "049973": { name: "Woodridge Local", county: "SUMM" },
  "045120": { name: "Wooster City", county: "WAYN" },
};

// Districts with no teachers union or collective bargaining agreement on SERB
// (issue #394, "Non-Union"). They never get a contract, so they are kept out of
// the other cards and out of the progress bar.
export const nonUnionDistricts = {
  "044289": { name: "Madeira City", county: "HAMI" },
  "044313": { name: "Mariemont City", county: "HAMI" },
  "044461": { name: "New Boston Local", county: "SCIO" },
  "047639": { name: "Lynchburg-Clay Local", county: "HIGH" },
  "047837": { name: "Danville Local", county: "KNOX" },
  "048835": { name: "East Muskingum Local", county: "MUSK" },
  "049593": { name: "Bloom-Vernon Local", county: "SCIO" },
};

export const snapshotDate = "2026-08-28";
